import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg fill="none" height="30" viewBox="0 0 30 30" width="30" xmlns="http://www.w3.org/2000/svg" {...props}><g stroke="#6a6a7c" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"><path d="M16.217 21.425a8.986 8.986 0 000-12.708M11.877 19.519a6.29 6.29 0 000-8.896" /></g></svg>);